import script from "./gmdialog.vue?vue&type=script&setup=true&lang=js"
export * from "./gmdialog.vue?vue&type=script&setup=true&lang=js"

import "./gmdialog.vue?vue&type=style&index=0&id=9c27173a&scoped=true&lang=css"

import exportComponent from "/data/jenkins/workspace/pay.7pa.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c27173a"]])

export default __exports__